import * as React from "react";
import { DropdownProps, Form } from "semantic-ui-react";
import { LinkObject } from "@teamprevent/common/model";

import { GenericCaseType } from "../../../genericCaseTypes/models";

interface Props {
    allGenericCaseTypes: GenericCaseType[];
    selectedGenericCaseTypes: LinkObject[];
    onGenericCaseTypeChange: (genericCaseTypes: LinkObject[]) => void;
}

export const GenericCaseTypeEdit: React.FunctionComponent<Props> = ({
    allGenericCaseTypes,
    selectedGenericCaseTypes,
    onGenericCaseTypeChange }) =>
{
    const genericCaseTypeOptions = React.useMemo(() =>
        [
            ...allGenericCaseTypes.filter(a => a.active && a.availableToCustomer).map(gct => ({ key: gct.id, value: gct.id, text: gct.name }))
        ],
    [allGenericCaseTypes]);

    const onGenericCaseTypeDropDownChange = React.useCallback((_, data: DropdownProps) => {
        const genericCaseTypeIds = data.value as string[];
        const genericCaseTypes = genericCaseTypeIds.map(gctId => {
            return allGenericCaseTypes.find(gct => gct.id === gctId);
        }).filter(gct => gct !== undefined) as LinkObject[];

        onGenericCaseTypeChange(genericCaseTypes);
    }, [allGenericCaseTypes, onGenericCaseTypeChange]);

    if (!genericCaseTypeOptions)
    {
        return null;
    }

    return (
        <>
            <Form.Dropdown
                selection
                multiple
                search
                label="Generic Case Types"
                options={genericCaseTypeOptions}
                onChange={onGenericCaseTypeDropDownChange}
                value={selectedGenericCaseTypes.map(org => org.id)}
            />
        </>
    );
};
